import { SpaceNotationStatusBadge } from '@/lib/space-notations/space-notation-badges';
import { toReadableDate } from '@/lib/dates';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  SpaceNotationConfig,
  type SpaceNotation,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const SpaceNotationItem: RelationFieldProps<SpaceNotation> = {
  nested: getRelationFieldNames(SpaceNotationConfig),
  renderItem: (item) => ({
    title: item.name,
    badge: <SpaceNotationStatusBadge notation={item} />,
    descriptionItems: (
      <div className='flex items-center'>
        <span>{item.category?.name ?? 'Ingen märkningstyp'}</span>
        <Dot />
        <span>
          {toReadableDate(item.startDate)} -{' '}
          {item.endDate ? toReadableDate(item.endDate) : 'Tillsvidare'}
        </span>
      </div>
    ),
  }),
};
